export const ACADEMY_INSIGHTS_WIZARD_SCORES_LINK = 'https://support.magicbrief.com/articles/1258182346-understanding-wizard-scores';
export const ACADEMY_LINK = 'https://magicbrief.academy/';
export const AD_SCORE_LIFECYCLE_LINK = 'https://magicbrief.academy/ad-scores';
export const AFFILIATE_LINK = 'https://magicbrief.com/partners';
export const FB_ADS_LIBRARY_LINK = 'https://www.facebook.com/ads/library';
export const FB_LINK = 'https://www.facebook.com';
export const EXTENSION_LINK = 'https://www.magicbrief.com/extension';
export const BROWSER_EXTENSION_SETUP_LINK = 'https://www.magicbrief.com/setup';
export const FEATURES_LINK = 'https://magicbrief.com/features';
export const HELP_LINK = 'https://support.magicbrief.com';
export const METRICS_GLOSSARY_LINK = 'https://magicbrief.academy/insights/metrics-glossary';
export const PRICING_LINK = 'https://magicbrief.com/pricing';
export const PRIVACY_LINK = 'https://magicbrief.com/privacy';
export const SLACK_LINK = 'https://magicbrief.com/slack';
export const SUPPORT_EMAIL = 'hello@magicbrief.com';
export const TERMS_LINK = 'https://magicbrief.com/terms';
export const TIKTOK_AD_LIBRARY_LINK = 'https://library.tiktok.com/ads';
export const TIKTOK_CREATIVE_CENTER_LINK = 'https://ads.tiktok.com/business/creativecenter';
export const TIKTOK_CREATIVE_LINK = 'https://ads.tiktok.com/business/creativecenter/inspiration/topads/pc/en';
export const TIKTOK_FOR_YOU_LINK = 'https://www.tiktok.com/foryou';
export const TIKTOK_ORGANIC_LINK = 'https://www.tiktok.com/discover';
export const TOUR_LINK = 'https://magicbrief.com/tour';
export const UPDATING_PAGE_PERMISSIONS_LINK = 'https://support.magicbrief.com/articles/1555518817-updating-page-permissions';
export const COPILOT_HELP_LINK = 'https://support.magicbrief.com/articles/8295609234-setting-up-copilot';
//# sourceMappingURL=index.js.map